var markers = [];
var scrollAnimationSpeed = 600;

function schoolPage() {
    $('#videos-tab').on('click', function () {
        $('.school-videos-tab-pane').addClass('show-videos-tab-pane');
        $('.school-videos-tab-pane').removeClass('hide-videos-tab-pane');
        $(".school-videos-tab-pane").css({"opacity": "1"});
        $(".school-videos-tab-pane").css({"visibility": "visible"});
	$('.school-google-photos-tab-pane').addClass('hide-google-photos-tab-pane');
        $(".school-google-photos-tab-pane").css({"opacity": "0"});
        $(".school-google-photos-tab-pane").css({"visibility": "hidden"});
    });

    $('#photos-tab').on('click', function () {
        $('.school-videos-tab-pane').addClass('hide-videos-tab-pane');
        $(".school-videos-tab-pane").css({"opacity": "0"});
        $(".school-videos-tab-pane").css({"visibility": "hidden"});
	$('.school-google-photos-tab-pane').addClass('hide-google-photos-tab-pane');
        $(".school-google-photos-tab-pane").css({"opacity": "0"});
        $(".school-google-photos-tab-pane").css({"visibility": "hidden"});
    });

    $('#google-photos-tab').on('click', function () {
        $('.school-google-photos-tab-pane').addClass('show-google-photos-tab-pane');
        $('.school-google-photos-tab-pane').removeClass('hide-google-photos-tab-pane');
        $(".school-google-photos-tab-pane").css({"opacity": "1"});
        $(".school-google-photos-tab-pane").css({"visibility": "visible"});
        $('.school-videos-tab-pane').addClass('hide-videos-tab-pane');
        $(".school-videos-tab-pane").css({"opacity": "0"});
        $(".school-videos-tab-pane").css({"visibility": "hidden"});
    });

    if ($('#videos-tab')[0])
    $('#videos-tab')[0].click();
    if ($('#photos-tab')[0])
    $('#photos-tab')[0].click();
}

//GOOGLE MAP FOR SCHOOLS
function initSchoolMap() {
    var mapZoom = 16;
    var map = new google.maps.Map(document.getElementById('school_map'), {
        scrollwheel: false,
    });


    var marker, i;
    var bounds = new google.maps.LatLngBounds();
    var infowindow = new google.maps.InfoWindow();
    for (i = 0; i < locations.length; i++) {
        var markerData = locations[i];
        marker = new google.maps.Marker({
            position: new google.maps.LatLng(markerData.lat, markerData.lng),
            map: map,
            visible: true,
            icon: {
                url: base_url + '/img/map_pointer.png'
            }
        });
        markers.push(marker);
        addSchoolMarkerContent(marker, map, markerData, infowindow);
        bounds.extend(marker.getPosition());
    }

    google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
        if (this.getZoom() > mapZoom) {
            this.setZoom(mapZoom);
        }
    });

    map.fitBounds(bounds);


}

function addSchoolMarkerContent(marker, map, markerData, infowindow) {
    google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent('<div>' + markerData.schoolName + '<br>' + markerData.schoolAddress + '</div>');
        infowindow.open(map, this);
    });
}


